import { render, staticRenderFns } from "./BaseEllipsis.vue?vue&type=template&id=3629b26f&scoped=true&"
import script from "./BaseEllipsis.vue?vue&type=script&lang=js&"
export * from "./BaseEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629b26f",
  null
  
)

export default component.exports